<template>
	<div class="c-nav__top">
		<nav class="navbar navbar-expand-lg navbar-light bg-light">
			<div class="container">
				<div class="navbar-brand">
					<img src="https://www.soleol.ch/assets/img/logo.svg" />
				</div>
				<ul class="navbar-nav ml-auto">
					<li class="nav-item dropdown">
						<a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							Client Soleol
						</a>
						<div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
							<button class="dropdown-item" @click.prevent="signOut()">Log Out</button>
						</div>
					</li>
				</ul>
			</div>
		</nav>
	</div>
</template>

<script>
	import { auth } from '../../firebase'

	export default {
		mounted() {
			this.$router.push('/user/files')
		},
		methods: {
			signOut() {
				auth.signOut().then( () => {
					this.$router.push('/')
				})
			}
		}
	}
</script>

<style>
	.navbar-brand{
		width: 180px;
	}
</style>



// WEBPACK FOOTER //
// src/components/user/Nav.vue